import * as React from 'react';
import '../../constants.js';
import { isInteger } from '../../utils/number.js';
import './Col.scss.js';

const getClassFor = (colSize) => (str, size) => {
  return isInteger(size) ? `${str} col-${colSize}-${size}` : `${str} col-${colSize}`;
};
const Col = (props) => {
  const className = React.useMemo(() => {
    const baseClass = "vai-col" + (props.className ? ` ${props.className}` : "");
    return ["xs", "sm", "md", "lg", "xl"].reduce((cn, colSize) => {
      return getClassFor(colSize)(cn, props[colSize]);
    }, baseClass);
  }, [props]);
  return /* @__PURE__ */ React.createElement("div", {
    className
  }, props.children);
};

export { Col };
